
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import InlineLoading from 'vux/src/components/inline-loading/index.vue'

import loadPage from '../../components/loadingPage'
import global from '../../../static/js/global'
export default {
data (){
return {
show_1:false,
list:[],
msDate:1,
phone:'',
}
},
components:{
Flexbox,
FlexboxItem,
loadPage,
InlineLoading
},
beforeMount(){
if(this.$router.history.current.path == "/commodityMesReply"){
document.title = "留言回复";
}
this.phone = this.$router.history.current.query.phone;
this.loadData(1);
},
mounted(){

mobilwmtouch(document.getElementById("g1"))
document.getElementById("g1").addEventListener('touup',this.touchup,false)
function mobilwmtouch(obj){
var stoux,stouy;
var etoux,etouy;
var xdire,ydire;
obj.addEventListener("touchstart",function (e){
stoux=e.targetTouches[0].clientX;
stouy=e.targetTouches[0].clientY;

},false);
obj.addEventListener("touchend",function (e){
etoux=e.changedTouches[0].clientX;
etouy=e.changedTouches[0].clientY;
xdire=etoux-stoux;
ydire=etouy-stouy;
let chazhi=Math.abs(xdire)-Math.abs(ydire);

if(xdire>0&&chazhi>0){
console.log("right");

obj.dispatchEvent(evenzc('touright'));

}else if(ydire>0&&chazhi<0){
console.log("down");
obj.dispatchEvent(evenzc('toudown'));
}else if(xdire<0&&chazhi>0){
console.log("left");
obj.dispatchEvent(evenzc('touleft'));
}else if(ydire<0&&chazhi<0){
console.log("up");
obj.dispatchEvent(evenzc('touup'));
}
},false);
}

function evenzc(eve){
let event = '';
if (typeof document.CustomEvent === 'function') {
event = new document.CustomEvent(eve, {//自定义事件名称
bubbles: false,//是否冒泡
cancelable: false
});
if(!document["evetself"+eve]){
document["evetself"+eve]= event;
}
} else if (typeof document.createEvent === 'function') {
event = document.createEvent('HTMLEvents');
event.initEvent(eve, false, false);
if(!document["evetself"+eve]){
document["evetself"+eve]=event;
}
} else {
return false;
}

return document["evetself"+eve];

}
},
methods:{
touchup(){
$(".am_absolt").show();
this.msDate++;
console.log(this.msDate)
this.loadData(this.msDate);
},
loadData(pages){//获取数据方法
this.show_1 = true;
let jsonData = {
receivePhone: this.$router.history.current.query.phone,
noticeType:'oldGoods',
page:pages,
rows: 4
};
let url = global.host + 'secondMarket/findnoticecenter';
this.$http.post(url,jsonData).then(function(res){

let picList = res.body;
for(let mv in picList){
this.list.push(picList[mv]);
}

this.show_1 = false;
$(".am_absolt").hide()

if(jsonData.rows != res.body.length){
document.getElementById("g1").removeEventListener('touup',this.touchup);
}
},function(err){
console.log(err)
})
}
}
}



// WEBPACK FOOTER //
// ./src/components/fleaMarketComponents/commodityMesReply.vue